import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import BubbleChart from "app/components/charts/BubbleChart";
import HighchartsMore from 'highcharts/highcharts-more.js';
import Exporting from 'highcharts/modules/exporting.js';
import ExportData from 'highcharts/modules/export-data.js';
import AnnotationsFactory from "highcharts/modules/annotations";

import {
	FormControl,
	MenuItem,
	Select,
	Typography,
} from "@mui/material";
import { logActivity } from "../../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

HighchartsMore(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);
AnnotationsFactory(Highcharts);

class IndustryJobTrends extends Component {
  	constructor(props) {
		super(props);
		this.state = {
            focusIndustry: ''
		};
        this.bubbleChartRef = React.createRef();
  	}

    addPropsToSeriesChart(series) {
        // console.log("series data", series)
        let colors = ["#FFB607", "#6AA4DC"];
        return (series.map((el,i) => ({
            ...el

        })));
    }

    getDataIndices = (seriesData, industry) => {
        let seriesInd = -1;
        let dataInd = -1;
        let logger = [];
        for (let i = 0; i < seriesData.length; i++) {
            const series = seriesData[i];
            let ind = series.data.findIndex((x) => {
                logger.push(x.name);
                return x.name === industry;
            });
            if (ind !== -1) {
                seriesInd = i;
                dataInd = ind;
                break;
            }
        }
        return { seriesInd: seriesInd, dataInd: dataInd };
    };

    syncWithFocusIndustry = (seriesData) => {
        if (this.props.focusIndustry !== this.state.focusIndustry) {
            if (this.bubbleChartRef && this.bubbleChartRef.current) {
                const chart = this.bubbleChartRef.current.chart;
                if (chart && chart.series) {
                    let { seriesInd, dataInd } = {
                        ...this.getDataIndices(chart.series, this.props.focusIndustry),
                    };
                    let prevSeriesMatch = this.getDataIndices(
                        chart.series,
                        this.state.focusIndustry
                    );
                    let prevSeriesInd = prevSeriesMatch.seriesInd,
                        prevDataInd = prevSeriesMatch.dataInd;
                    if (prevDataInd !== -1) {
                        chart.series[prevSeriesInd].points[prevDataInd].update({
                            color: chart.series[prevSeriesInd].color,
                        });
                        chart.tooltip.hide();
                    }
                    if (dataInd !== -1) {
                        chart.series[seriesInd].points[dataInd].update({
                            color: "#00FFFF",
                        });
                        chart.tooltip.refresh(chart.series[seriesInd].points[dataInd]);
                    }
                }
            }
            this.setState({ focusIndustry: this.props.focusIndustry });

            // logActivity({
            //     screen : UserActivityConstants.SCREEN2.NAME,
            //     action_type : UserActivityConstants.ACTION_TYPES.HOVER,
            //     action : UserActivityConstants.SCREEN2.ACTIONS.FOCUS_INDUSTRY,
            //     action_target : this.props.focusIndustry
            // })
        }
    };

  	render() {
        let growthData = Object.values(this.props.growthData);
        this.syncWithFocusIndustry(growthData);
		return (
	  		<div className="graph-wrapper screen-left-graph-container">
				<div className="graph-title-container">
					<div className="graph-title">Industry concentration and projected change</div>
				</div>
				<div className="graph-screen graph-screen2">
					<div className="individual-graph-2">
					<BubbleChart
						containerId="bubbleChart"
                        bubbleChartRef={this.bubbleChartRef}
						remainingOptions={{
                            chart: {
                                animation: false,
                                type: 'bubble',
                                plotBorderWidth: 1,
                                zoomType: 'xy',
                                backgroundColor: 'transparent',
								height: 685,
								width: 800,
								spacingTop: 20,
                            },

                            legend: {
                                enabled: false
                            },

                            title: {
                                text: null
                            },

                            annotations: [{
                                labelOptions: {
                                    y: 0,
                                    shape: 'rect',
                                    backgroundColor: '#FFFFFF',
                                    borderColor: 'none',
                                    style: {
                                        fontFamily: 'Arial',
                                        fontSize: '16px'
                                    }
                                },
                                labels: [{
                                    point: {
                                        x: 0,
                                        y: 0
                                    },
                                    text: 'Strong and Declining'
                                }, {
                                    point: {
                                        x: 800,
                                        y: 0
                                    },
                                    text: 'Strong and Growing'
                                }, {
                                    point: {
                                        x: 0,
                                        y: 665
                                    },
                                    text: 'Weak and Declining'
                                }, {
                                    point: {
                                        x: 800,
                                        y: 665
                                    },
                                    text: 'Weak and Growing'
                                }]
                            }],

                            xAxis: {
                                gridLineWidth: 0.5,
                                title: {
                                    text: '% Change in Location Quotient',
                                    style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									}
                                },
                                labels: {
                                    format: '{value}%',
                                    style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									},
                                },
                                plotLines: [{
                                    color: '#fff',
                                    dashStyle: 'dot',
                                    width: 2,
                                    value: 0,
                                    label: {
                                        rotation: 0,
                                        y: 15,
                                        style: {
                                            fontStyle: 'italic'
                                        },
                                        text: null
                                    },
                                    zIndex: 3
                                }]
                            },

                            yAxis: {
                                startOnTick: false,
                                endOnTick: false,
                                gridLineWidth: 0.5,
                                title: {
                                    text: '2023 Location Quotient',
                                    style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									}
                                },
                                labels: {
                                    format: '{value}',
                                    style: {
										color: "#fff",
										font: "normal normal normal 18px Arial"
									},
                                },
                                maxPadding: 0.2,
                                plotLines: [{
                                    color: '#fff',
                                    dashStyle: 'dot',
                                    width: 2,
                                    value: 1,
                                    label: {
                                        align: 'right',
                                        style: {
                                            fontStyle: 'italic'
                                        },
                                        text: null,
                                        x: 1.5
                                    },
                                    zIndex: 3
                                }]
                            },

                            tooltip: {
                                style: {
                                    font: "Arial",
                                    fontSize: "14px",
                                    color: "#333333",
                                    zIndex: 999
                                },
                                useHTML: true,
                                headerFormat: '<table>',
                                pointFormat: '<tr><td>Industry:</td><th>{point.name}</th></tr>' +
                                    '<tr><td>Location Quotient:</td><th>{point.y}</th></tr>' +
                                    '<tr><td>Change (2023-2033):</td><th>{point.x} %</th></tr>' +
                                    '<tr><td>Total Number of Jobs:</td><th>{point.zFormatted}</th></tr>',
                                footerFormat: '</table>',
                                followPointer: true,
                                borderRadius: 15,
                                borderWidth: 1,
                                borderColor: "#707070",
                                backgroundColor: "#FFFFFF",
                                padding: 17,
                                shape: "square"
                            },

                            plotOptions: {
                                series: {
                                    animation: false,
                                    dataLabels: {
                                        enabled: false,
                                        format: '{point.name}'
                                    }
                                }
                            },

                            series: [{
                                data: growthData,
                                colorByPoint: false
                            }],
                            exporting: { enabled: false }

						}}
					/>
					</div>
				</div>
			</div>
		);
  	}
}


export default IndustryJobTrends;
